/*
* IMPORTANT NOTE ABOUT THIS FILE:
*
* The bundle file generated for this component, along with vendor.bundle.js,
* needs to be placed on the old CMP site under "/cb/cb/js/feedback/". Since
* the two sites have separate code, we have to bundle this component and import it
* manually into the CMP project.
*
*/

import React from 'react'
import { connect } from 'react-redux'
import {
  getModules,
  submitFeedback,
  submitFeedbackCMP,
  submitFeedbackSuccess
} from '../actions'

const supportText = {
  fontSize: '12px',
  fontWeight: '600',
  color: '#006747'
}

const mapStateToProps = state => {
  return {
    modules: state.modules,
    voluntary: state.voluntary,
    feedbackSuccess: state.feedbackSuccess,
  }
}

const mapDispatchToProps = {
  getModules,
  submitFeedback,
  submitFeedbackCMP,
  submitFeedbackSuccess
}

class FeedbackForm extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      text: '',
      submitEmpty: false,
      selectError: false
    }
    this.feedbackText = React.createRef()
    this.pageSelect = React.createRef()
  }

  static defaultProps = {
    message: 'How can we make Commerce Connections® better for you?',
    selectOptions: [
      {id: 1, name: 'Account Inquiry'},
      {id: 2, name: 'Admin'},
      {id: 3, name: 'Check Management'},
      {id: 4, name: 'Home Page'},
      {id: 5, name: 'Payments & Transfers'},
      {id: 6, name: 'Pending Approvals'},
      {id: 7, name: 'Reporting'},
      {id: 8, name: 'General Feedback'},
    ],
  }

  componentDidMount () {
    this.props.getModules()

    $('#feedbackForm').on('shown.cb.modal', () => {
      // reset the select box
      this.pageSelect.current.selectedIndex = '0'

      // reset the text box
      this.feedbackText.current.value = ''

      // reset the character counter
      this.setState({text: ''})
    })

    $('#feedbackForm').on('hidden.cb.modal', () => {
      this.setState({
        submitEmpty: false,
        selectError: false
      })
    })
  }

  setText = e => {
    this.setState({text: e.target.value})
  }

  showConfirmation = () => {
    $('#feedbackForm').cbModal('hide')
    $('#feedbackConfirm').cbModal('show')
  }

  submit = () => {
    let text = this.feedbackText.current.value
    let selectError = false
    let lengthError = false

    if (this.pageSelect.current.value === "0") {
      selectError = true
      this.setState({selectError: true})
    } else {
      this.setState({selectError: false})
    }

    if (text.length <= 0) {
      lengthError = true
      this.setState({submitEmpty: true})
    } else {
      this.setState({submitEmpty: false})
    }

    if (!lengthError && !selectError) {
      let params = {
        moduleId: parseInt(this.pageSelect.current.value, 10),
        voluntary: 1,
        message: text
      }
      this.props.submitFeedback(params)
      // this.props.submitFeedbackCMP(params)

      $('#feedbackForm').cbModal('hide')
    }
  }

  renderOptions = () => {
    let items = [], options = []

    if (this.props.modules && this.props.modules.length > 0)
      options = this.props.modules
    else
      options = FeedbackForm.defaultProps.selectOptions

    items.push(<option key={0} disabled value={'0'} hidden>Select a Category</option>)

    for (let i = 0; i < options.length; i++) {
      items.push(
        <option key={options[i].id} value={options[i].id}>
          {options[i].name}
        </option>
      )
    }

    return items
  }

  render () {
    let charCount = 2000 - this.state.text.length

    const errorBorder = '1px solid #ff0000'

    return (
      <div className='cb-modal cb-fade' id='feedbackForm'>
        <div className='cb-modal-dialog' role='document'>
          <div className='cb-modal-content'>
            <div className='cb-modal-header'>
              <h2 className='cb-modal-title'>Feedback</h2>
              <i className='cb-close cb-icon icon-close' aria-hidden='true' data-dismiss='cb-modal' aria-label='Close'/>
            </div>
            <div className='cb-modal-body'>
              <div className='cb-form-group'>
                <label className='cb-from-control-label'>{FeedbackForm.defaultProps.message}</label>
                <div className="cb-select" style={{marginBottom: '.75rem'}}>
                  <select className='cb-form-control'
                          id='feedback-select'
                          defaultValue={'0'}
                          onChange={() => { this.feedbackText.current.focus() }}
                          ref={this.pageSelect}>
                    {this.renderOptions()}
                  </select>
                </div>
                <textarea
                  className='cb-form-control textbox'
                  id='feedbackText'
                  maxLength='2000'
                  onChange={this.setText}
                  placeholder={'Your suggestions, ideas, and comments are appreciated!'}
                  ref={this.feedbackText}
                />
                <p>Characters remaining: {charCount}</p>
                {
                  this.state.submitEmpty &&
                  <div className='cb-notification cb-notification-notify'>
                    <i className='cb-icon icon-warning'/>
                    <span className='cb-notification-text'>
                      Please provide some feedback before submitting.
                    </span>
                  </div>
                }
                {
                  this.state.selectError &&
                  <div className='cb-notification cb-notification-notify'>
                    <i className='cb-icon icon-warning'/>
                    <span className='cb-notification-text'>
                      Please select a category before submitting.
                    </span>
                  </div>
                }
                <p style={supportText}>
                  Feedback is not monitored daily. If you have a question regarding your accounts or services,
                  please contact Commercial Customer Support at 800-207-0886.
                </p>
              </div>
            </div>
            <div className='cb-modal-footer'>
              <button type='button'
                      className='cb-btn cb-btn-primary btn-pad'
                      // data-dismiss={(!this.state.submitEmpty && !this.state.selectError) ? 'cb-modal' : ''}
                      data-toggle='cb-modal'
                      data-target='feedbackConfirm'
                      onClick={() => { this.submit() }}>
                Send
              </button>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(FeedbackForm)
